import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/banner2/icon-terminal.png'
import _imports_1 from '../../assets/img/step/step-top.svg'
import _imports_2 from '../../assets/img/step/step-ico.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2e9c894b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<header class=\"banner\" data-v-2e9c894b><div class=\"banner-content\" data-v-2e9c894b><div class=\"banner-text\" data-v-2e9c894b><p class=\"banner-title\" data-v-2e9c894b>互联专家抽取终端</p><p class=\"banner-desc\" data-v-2e9c894b>助力建设全国统一大市场，优化市场营商环境</p></div><img src=\"" + _imports_0 + "\" alt=\"\" class=\"banner-img\" data-v-2e9c894b></div></header>", 1)
const _hoisted_3 = { class: "box" }
const _hoisted_4 = { class: "stepbox" }
const _hoisted_5 = { class: "stepitembg" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overtop" }, null, -1))
const _hoisted_7 = { class: "stepitem" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    style: {"width":"133px","height":"70px"}
  })
], -1))
const _hoisted_9 = { class: "stepindex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepico" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    style: {"width":"32px","height":"35px"}
  })
], -1))
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  style: {"display":"flex","margin-top":"44px","justify-content":"space-evenly","padding":"0 10px"}
}
const _hoisted_14 = {
  key: 1,
  style: {"display":"flex","margin-top":"34px","justify-content":"space-evenly","padding":"0 10px"}
}

import { ref } from 'vue'
import mytitle from '../../components/title.vue'
import contactUs from '../../components/contactUs.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'expertExtractionTerminal',
  setup(__props) {

const stepInfo = ref<{
  title: string
  description: string
  url?: string
  contactUs?: boolean
  showContact?: boolean
}[]>([
  {
    title: '阅读接入指南',
    description: '预览、下载《远程异地评标和评标专家库共享技术标准_专家抽取终端接入指南》',
    url: 'S09远程异地评标和评标专家库共享技术标准_专家抽取终端接入指南_20250605_1600.pdf',
  },
  {
    title: '提供专家抽取终端页面',
    description: '根据《远程异地评标和评标专家库共享技术标准_专家抽取终端接入指南》，提供专家抽取终端页面。',
    url: 'S09远程异地评标和评标专家库共享技术标准_专家抽取终端接入指南_20250605_1600.pdf',
  },
  {
    title: '与跨省评标专家库共享<br/>目录服务组件共同联调测试',
    description: '与跨省评标专家库共享目录服务组件共同联调测试。',
  },
])

const preview = (url: string) => {
  window._czc.push(['_trackEvent', '专家抽取终端', '预览', '专家抽取终端接入指南预览'])
  window.open(url, '_blank')
}
const download = (url: string) => {
  window._czc.push(['_trackEvent', '专家抽取终端', '下载', '专家抽取终端接入指南预览'])
  const link = document.createElement('a')
  link.href = url
  link.download = url
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createVNode(mytitle, {
        title: "对接实施具体步骤",
        style: {"margin-top":"64px"}
      }),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepInfo.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (item.title)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_6,
                  _withDirectives(_createVNode(contactUs, null, null, 512), [
                    [_vShow, item.showContact]
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, _toDisplayString(index + 1), 1),
                    _hoisted_10,
                    _createElementVNode("div", {
                      class: "stepTitle",
                      innerHTML: item.title
                    }, null, 8, _hoisted_11),
                    _createElementVNode("div", {
                      class: "stepText",
                      innerHTML: item.description
                    }, null, 8, _hoisted_12),
                    (item.url)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_el_button, {
                            class: "btn2",
                            onClick: ($event: any) => (preview(item.url))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("预览")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            class: "btn1",
                            onClick: ($event: any) => (download(item.url))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下载")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.contactUs)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_el_button, {
                            class: "btn2",
                            style: {"width":"356px"},
                            onMouseover: ($event: any) => (item.showContact = true),
                            onMouseleave: ($event: any) => (item.showContact = false)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("联系我们")
                            ]),
                            _: 2
                          }, 1032, ["onMouseover", "onMouseleave"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]))
        }), 256))
      ])
    ])
  ]))
}
}

})